module.exports = __webpack_public_path__ + "img/software.fad609d9.jpg";